import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import { privateRoutes, routes } from "./pages/index";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Assets/css/style.css";
import "./Assets/css/responsive.css";
import AuthLayout from "./layout/Auth/authLayout";
import MainLayout from "./layout/MainLayout/MainLayout";
import { useSelector } from "react-redux";
import { updateToken } from "helpers/api_helper";
import { useEffect } from "react";
import ProtectedRoute from "components/Protected-Route/ProtectedRoute";
import PublicRoute from "components/Public-Route/PublicRoute";
import SubscriptionRoute from "components/SubscriptionBuy";
import TermsConditions from "components/TermsConditions";

function App() {
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    if (token) {
      updateToken(token);
    }
  }, [token]);

  return (
    <Routes>
      <Route path="/terms-and-conditions" element={<TermsConditions />} />
      <Route element={<AuthLayout />}>
        <Route index element={<Navigate to="/login" />} />
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={<PublicRoute element={route.component} />}
          />
        ))}
      </Route>

      <Route path="/" element={<MainLayout />}>
        <Route index element={<Navigate to="/home" />} />

        {privateRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={<ProtectedRoute route={route} />} />
        ))}
      </Route>
    </Routes>
  );
}

export default App;
